import { useEffect, useState } from 'react';

// Жёсткий фильтр рекламы «Активные / Все»: действует на все списки и разбивки РК.
// Активные — идут или запланированы; выключенные, завершённые и архивные скрыты.
const KEY = 'anylex_ads_scope';
const EVENT = 'anylex-ads-scope';

export function getAdsScope() {
  try {
    return localStorage.getItem(KEY) === 'all' ? 'all' : 'active';
  } catch {
    return 'active';
  }
}

export function setAdsScope(scope) {
  try {
    localStorage.setItem(KEY, scope === 'all' ? 'all' : 'active');
  } catch { /* хранилище недоступно */ }
  window.dispatchEvent(new Event(EVENT));
}

// Хвост запроса к API: пусто для «Все».
export function adsScopeParam() {
  return getAdsScope() === 'active' ? '&active_only=true' : '';
}

export function useAdsScope() {
  const [scope, setScope] = useState(getAdsScope);
  useEffect(() => {
    const sync = () => setScope(getAdsScope());
    window.addEventListener(EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  return scope;
}
